// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__5HLNz","footer_line":"styles_footer_line__2a7lp","spin":"styles_spin__v3cr6"};